// node_modules
import { FC, useState, MouseEvent, CSSProperties } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons";
// Types
import { T2dCoordinate, TTechnology } from "Types";
// Components
import { TechnologySideNotesModal } from "../../TechnologySideNotes";
// styles
import styles from './technologyListItemSideNotes.module.scss';
// Logics
import { SideNoteLogicSingleton } from "Logics";

type TTechnologyListItemSideNotesProps = {
    technology: TTechnology
}

export const TechnologyListItemSideNotes: FC<TTechnologyListItemSideNotesProps> = ({technology}: TTechnologyListItemSideNotesProps) => {
    // State
    const [isCursorStillOnSideNotesIcon, setIsCursorStillOnSideNotesIcon] = useState<boolean>(false);
    const [isCursorStillOnSideNotesModal, setIsCursorStillOnSideNotesModal] = useState<boolean>(false);
    const [modalDimensions, setModalDimensions] = useState<T2dCoordinate>({x: 0, y: 0});
    const [sideNotesIconPosition, setSideNotesIconPosition] = useState<T2dCoordinate>({x: 0, y: 0});

    // Logic
    const displayTechnologySideNotesModal = (mouseEvent: MouseEvent): void => {
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();
        const targetElement = mouseEvent.currentTarget;
        const sideNotesContainer = targetElement.parentElement;
        const modalContent = sideNotesContainer?.querySelector("div[class^='technologySideNotesModal_technologySideNotesModal']");
        if(modalContent) {
            setModalDimensions({x: modalContent.getBoundingClientRect().width, y: modalContent.getBoundingClientRect().height});
        }
        setSideNotesIconPosition({x: mouseEvent.currentTarget.getBoundingClientRect().left, y: mouseEvent.currentTarget.getBoundingClientRect().top});
        setIsCursorStillOnSideNotesIcon(true);
    }

    const hideTechnologySideNotesModal = (mouseEvent: MouseEvent): (() => void) => {
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();

        const delayDebounceFn = setTimeout(() => {
            setIsCursorStillOnSideNotesIcon(false);
        }, 100)
        return () => clearTimeout(delayDebounceFn);
    }

    const getSideNotesIconClassNames = (): string => {
        let sideNotesIconClassNames: string[] = [styles.fontAwesomeItem];
        if (technology.sideNotes.length > 0) sideNotesIconClassNames.push(styles.hasSideNotes);
        return sideNotesIconClassNames.join(" ");
    }

    const onMouseLeaveSideNotesModal = (): void => {
        setIsCursorStillOnSideNotesModal(false);
        resetPositions();
    };

    const onMouseEnterSideNotesModal = (): void => {
        setIsCursorStillOnSideNotesModal(true);
    };

    const getModalStyle = (): CSSProperties => {
        let newModalStyle: CSSProperties = {};

        if (isCursorStillOnSideNotesIcon || isCursorStillOnSideNotesModal) {
            // Set left position
            newModalStyle.left = `${sideNotesIconPosition.x + 28}px`;
            // Set top position
            if (sideNotesIconPosition.y + modalDimensions.y - 32 > window.innerHeight - 16) {
                newModalStyle.top = `${window.innerHeight - modalDimensions.y - 16}px`;
            } else {
                newModalStyle.top = `${sideNotesIconPosition.y -25}px`;
            }
            // Show modal
            newModalStyle.opacity = "1";
            newModalStyle.pointerEvents = "initial";
        }

        return newModalStyle;
    };

    const resetPositions = (): void => {
        setModalDimensions({x: 0, y: 0});
        setSideNotesIconPosition({x: 0, y: 0});
    };

    return (
        <div>
            <div
            onMouseEnter={displayTechnologySideNotesModal} 
            onMouseLeave={hideTechnologySideNotesModal}>
                <span className="fa-layers fa-fw" style={{minWidth: "1.25rem", fontSize: "1rem"}}>
                    <FontAwesomeIcon icon={faCommentAlt} className={getSideNotesIconClassNames()}></FontAwesomeIcon>
                    <span className={`fa-layers-text ${styles.fontAwesomeOverlayedNumber} ${styles.commentOverlay}`} >
                        {SideNoteLogicSingleton.getSideNotesCount(technology.sideNotes)}
                    </span>
                </span>
            </div>
            <div className={styles.technologySideNotesModalContainer} style={getModalStyle()}>
                <TechnologySideNotesModal 
                    handleOnMouseLeaveModal={onMouseLeaveSideNotesModal} 
                    handleOnMouseEnterModal={onMouseEnterSideNotesModal} 
                    technology={technology} />
            </div>
        </div>
                
    );
};